export enum PrivateRouteProps {
  USER = 'user',
}
